import React from "react";
import LOGO from "../Assets/logoDelhi.png";
import LanguageSelector from "./LanguageSelector";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { loader } from "../redux/type";
import { auth } from "../redux/type";
import { Navigate, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useState } from "react";
import { motion } from "framer-motion";
import { LogOut, User } from "lucide-react";

const Header = () => {


   const [isOpen, setIsOpen] = useState(false);
  
      const toggleDropdown = () => setIsOpen(!isOpen);
    
  const isLogin = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate=useNavigate();
  const { t } = useTranslation();
  function handleLogOut() {
    dispatch({ type: loader.startLoader });
    dispatch({
      type: auth.logout,
      payload: 'logout'
    });
    navigate("/")
    dispatch({ type: loader.stopLoader });
   
    
    
  }

  return (
    <>
      <header class="container-fluid ">
        <div className="row">
          {/* <div class=" d-flex justify-content-between align-items-center"> */}
          <div class="d-lg-flex justify-content-between align-items-center">
            <div class=" d-flex align-items-center">
              <img src={LOGO} alt="DDA" />
              

             
            </div>

            <h5>Services</h5>

            <Link to="/FAQs"> <h5 >FAQs</h5></Link>  
              <h5>Quick Links</h5>
 



            <div class=" header_right d-flex align-items-center">
              <LanguageSelector />

              {/* <button
                          onClick={handleLogout}
                          className="w-full flex items-center gap-2 px-4 py-2 text-gray-300 hover:bg-gray-800 transition"
                        >
                          <LogOut className="w-5 h-5" />
                          Log Out
                        </button> */}

            
             
{isLogin.signIn===true?

<>
<button
                          onClick={handleLogOut}
                          className="w-full btn-primary flex items-center gap-2 px-4 py-2 text-gray-300 hover:bg-gray-800 transition"
                        >
                          <LogOut className="w-4 h-4" />
                          Log Out
                        </button>

</>
              // <div className="nav-item dropdown">
              //   <a
                  
              //     className="nav-link dropdown-toggle d-flex align-items-center"
              //     data-bs-toggle="dropdown"
              //     id="12"
              //     role="button"
              //     aria-expanded="false"
              //   >
              //     <i className="fas fa-user-circle header_iconbig" onClick={handleLogOut}></i>
              //   </a>
              //   <div className="dropdown-menu dropdown-menu-end" aria-labelledby="12">
              //     <span className="dropdown-item text-muted">ABC</span>
              //     <hr className="dropdown-divider" />
              //     <button className="dropdown-item" >Log Out</button>
              //   </div>
              // </div>
          :<></>}

    

            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
